import { defineStore } from 'pinia';

export const commonSpinner = defineStore({
    id: 'commonSpinner',
    state: () => ({
        loading: false,
    }),
    actions: {
        setLoading() {
            if (this.loading) {
                setTimeout(() => {
                    this.loading = false;
                }, 100);
            }
            this.loading = true;
        },
        sleep(sec) {
            return new Promise(resolve => setTimeout(resolve, sec * 100));
        }
    }
});